
const timeout = 13000;  //api请求超时时间
let baseApiURL = process.env.NODE_ENV === 'development'? 'https://hygs.lnkj1.com/api/' : '/api/';  //api原始链接
export default{
    baseApiURL,
    timeout,
};